import { DebiCheckServiceApiFactory, type ModelDebiCheckRequest } from '@layup/api-sdk';
import { createLayupClient } from './layupApi';

export const debiCheckServiceClient = () => {
  const client = createLayupClient();
  return DebiCheckServiceApiFactory(undefined, undefined, client);
};

export const createMandate = async (modelDebiCheckRequest: ModelDebiCheckRequest) => {
  const response = await debiCheckServiceClient().debiCheckServiceCreate({
    modelDebiCheckRequest,
  });
  return response.data;
};

export const getMandate = async (id: string) => {
  const response = await debiCheckServiceClient().debiCheckServiceGetMandate({
    id,
  });
  return response.data;
};

export const getMandates = async (id: string) => {
  const response = await debiCheckServiceClient().debiCheckServiceGetMandateList({
    id,
  });
  return response.data;
};

export const simulateMandateResponse = async (id: string, status: 'Accepted' | 'Rejected') => {
  const client = createLayupClient(false);
  const response = await client.post(`/v1/simulate/absa-callback/${id}`, { type: 1, status });
  return response.data;
};
